<template>
  <div id="app">
    <profile-dialog/>

    <transition name="fade" :duration="{ enter: 2000, leave: 2000 }">
      <div class="loader" v-if="loading"></div>
    </transition>

    <router-view></router-view>
  </div>
</template>

<script>
import ProfileDialog from "./components/dialog/ProfileDialog"
import {mapState} from "vuex"

export default {
  name: 'App',
  components: {
    ProfileDialog
  },
  created() {
    // if (process.env.VUE_APP_BUILD_NUMBER)
    window.vue = () => {
      return console.info('%cARM – ' + (process.env.VUE_APP_BUILD_NUMBER ? process.env.VUE_APP_BUILD_NUMBER : ''), `
          display: block;
          width: 100%;
          padding: 20px 20px 10px;
          color: #D1FB84;
          background-color: #25291F;
          font: 800 1.3em monospace;
          text-shadow: 0 0 10px #D1FB84;
          border-radius: 5px`);
    }
  },
  computed: {
    ...mapState("loader", {
      loading: state => state.loading
    })
  }
}
</script>

<style>
@font-face {
  font-family: 'San Francisco Pro';
  src: local('San Francisco Pro Display Regular'), local('San-Francisco-Pro-Display-Regular'),
  url('./assets/fonts/SFProDisplay-Regular.woff2') format('woff2'),
  url('./assets/fonts/SFProDisplay-Regular.woff') format('woff'),
  url('./assets/fonts/SFProDisplay-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'San Francisco Pro';
  src: local('San Francisco Pro Display Medium'), local('San-Francisco-Pro-Display-Medium'),
  url('./assets/fonts/SFProDisplay-Medium.woff') format('woff'),
  url('./assets/fonts/SFProDisplay-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'San Francisco Pro';
  src: local('San Francisco Pro Display Semibold'), local('San-Francisco-Pro-Display-Semibold'),
  url('./assets/fonts/SFProDisplay-Semibold.woff') format('woff'),
  url('./assets/fonts/SFProDisplay-Semibold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'San Francisco Pro', sans-serif, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;


}

#app {
  margin: 0;
}

.loader {
  height: 2px;
  position: absolute;
  top: 0;
  z-index: 20;

  background-image: linear-gradient(115deg, #4fcf70, #fad648, #a767e5, #12bcfe, #44ce7b);
  animation: loader_width .5s linear infinite;
  transition: all .1s;
}

@-webkit-keyframes loader_width {
  0%, to {
    background-image: linear-gradient(115deg, #4fcf70, #fad648, #a767e5, #12bcfe)
  }
  25% {
    background-image: linear-gradient(115deg, #fad648, #a767e5, #12bcfe, #4fcf70)
  }
  50% {
    background-image: linear-gradient(115deg, #a767e5, #12bcfe, #4fcf70, #fad648)
  }
  75% {
    background-image: linear-gradient(115deg, #12bcfe, #4fcf70, #fad648, #a767e5)
  }
}

@keyframes loader_width {
  0%, to {
    background-image: linear-gradient(115deg, #4fcf70, #fad648, #a767e5, #12bcfe)
  }
  25% {
    background-image: linear-gradient(115deg, #fad648, #a767e5, #12bcfe, #4fcf70)
  }
  50% {
    background-image: linear-gradient(115deg, #a767e5, #12bcfe, #4fcf70, #fad648)
  }
  75% {
    background-image: linear-gradient(115deg, #12bcfe, #4fcf70, #fad648, #a767e5)
  }
}


</style>
